
export function isRightToLeft(LanguageCode: string): boolean {

  return LanguageCode === 'ar';
}
